<template>
    <div>
        <button class="btn btn-sm btn-primary pl-4 pr-4" @click.prevent="clickVerifyBtn()">
            {{ $t('profile.label.verify.authenticator') }}
        </button>
    </div>
</template>
<script>
    import IConstants from '@/common/constants/IConstants'
    import ServiceUtils from "@/common/utils/ServiceUtils"
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";
    import Config from "@/services/Config";
    import {floor} from "lodash";
    import $ from "jquery";

    import {createNamespacedHelpers} from "vuex";

    const {mapMutations: mapProfileMutations} = createNamespacedHelpers("editProfile");

    export default {
        name: "VerifyAuthentication",
        mixins: [],
        props: {
            screenNameProps: {
                type: String,
                require: true
            },
        },
        data() {
            return {
                supportLink: Config.getRegisterPasskeySupportLink(),
            }
        },
        validations() {
            return {}
        },
        computed: {},
        mounted() {
            this.listenEvents()
        },
        beforeDestroy() {
            this.unListenEvents()
        },
        methods: {
            ...mapProfileMutations(['assignProfileState']),
            async clickVerifyBtn() {
                const authInfo = await this.getAuthenticationInfo(true);
                if (!authInfo) return this.showProfileMsg(null, 'MSG_NAB005', null);

                if (ServiceUtils.currentScreenMaskingVerified(authInfo, this.screenNameProps)) return window.location.reload();
                else {
                    if (String(authInfo.authType) === String(IConstants.AUTH_TYPE.OTP)) this.initAuthenticateOTP(authInfo);
                    else if (String(authInfo.authType) === String(IConstants.AUTH_TYPE.PASSKEY)) this.reAuthenticatePasskey()
                }
            },
            initAuthenticateOTP(res) {
                this.$modal.showOtpMailChoosing({
                    ...res,
                    screenName: this.screenNameProps
                })
            },
            reAuthenticatePasskey() {
                if (ServiceUtils.isFidoAuthenticateUnsupported()) return this.$modal.showFidoAuthenticateUnsupported()

                this.$service
                    .getService(IConstants.SERVICE_NAME.FIDO)
                    .initReAuthenticatePasskey()
                    .then(async (res) => {
                        if (res.errorMessage) return this.showProfileMsg(null, null, this.getVerifyPasskeyFailedMsg());

                        let assertion = await navigator.credentials.get(ServiceUtils.genGetAssertionRequestV1(res))
                        if (!assertion) return this.showProfileMsg(null, null, this.getVerifyPasskeyFailedMsg());

                        let requestPayload = {
                            customerId: res.customerId,
                            fidoUserId: res.fidoUserId,
                            fidoRegistrationId: res.fidoRegistrationId,
                            fidoRegistrationChallengeId: res.fidoRegistrationChallengeId,
                            authenticationRequestId: res.authenticationRequestId,
                            w3cGetAssertionResponse: ServiceUtils.genW3cGetAssertionResponse(assertion),
                            authenticateScreenName: this.screenNameProps
                        }
                        this.$service
                            .getService(IConstants.SERVICE_NAME.FIDO)
                            .reAuthenticatePasskey(requestPayload, {headers: {'Content-Type': 'application/json'}})
                            .then((res) => {
                                if (res.errorMessage) return this.showProfileMsg(null, null, this.getVerifyPasskeyFailedMsg());
                                this.runUnMaskingLogicForScreens(this.screenNameProps);
                            })
                    })
                    .catch((e) => {
                        if (ServiceUtils.isUserCancelOrTimeoutPasskeyAction(e)) return;
                        if (ServiceUtils.isDeviceNotSupportPasskey(e)) return this.$modal.showFidoAuthenticateUnsupported();
                        this.showProfileMsg(null, null, this.getVerifyPasskeyFailedMsg())
                    })
                    .finally(() => {
                    })
            },
            listenEvents() {
                let self = this;
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.CLOSE_OTP_INPUT_RESULT, () => {
                    this.runUnMaskingLogicForScreens(self.screenNameProps)
                });
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.RE_ASSIGN_PROFILE_STATE_EVENT, (params) => {
                    this.reAssignProfileState(params.authInfo, params.screenName);
                });
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.RE_ASSIGN_PROFILE_STATE_AND_RE_EMIT_MASKING_VERIFIED_EVENT, (params) => {
                    this.reAssignProfileState(params.authInfo, params.screenName);
                    this.reEmitMaskingVerifiedEvent(params.authInfo, params.screenName)
                });
            },
            unListenEvents() {
                ModalPlugin.EventBus.$off(this.IConstants.EVENT_NAME.CLOSE_OTP_INPUT_RESULT);
                ModalPlugin.EventBus.$off(this.IConstants.EVENT_NAME.RE_ASSIGN_PROFILE_STATE_EVENT);
                ModalPlugin.EventBus.$off(this.IConstants.EVENT_NAME.RE_ASSIGN_PROFILE_STATE_AND_RE_EMIT_MASKING_VERIFIED_EVENT);
            },
            async runUnMaskingLogicForScreens(screenName) {
                let authInfo;
                if (IConstants.SCREEN_NAME.CUSTOMER_INFO === String(screenName)) authInfo = await this.runUnMaskingLogicForProfileScreen();
                if (IConstants.SCREEN_NAME.CUSTOMER_REPORT === String(screenName)) authInfo = await this.runUnMaskingLogicForReportScreen();
                if (IConstants.SCREEN_NAME.WITHDRAWAL === String(screenName)) authInfo = await this.runUnMaskingLogicForWithdrawalScreen();

                this.reAssignProfileState(authInfo, screenName);
                this.reEmitMaskingVerifiedEvent(authInfo, screenName)
            },
            reAssignProfileState(authInfo, screenName) {
                this.assignProfileState({maskingVerifiedPerSession: authInfo.maskingVerifiedPerSession});
                if (ServiceUtils.getMaskingPerRequestScreens().includes(screenName))
                    this.assignProfileState({maskingVerifiedPerRequest: authInfo.maskingVerifiedPerRequest});
            },
            reEmitMaskingVerifiedEvent(authInfo, screenName) {
                this.$modal.emitMaskingVerifyResult(IConstants.SCREEN_NAME.HEADER, {});
                this.$modal.emitMaskingVerifyResult(screenName, {});
            },
            async runUnMaskingLogicForProfileScreen() {
                const res = await this.$service
                    .getService(IConstants.SERVICE_NAME.PROFILE)
                    .getAmsCustomerInfo(IConstants.ACTIVE_MASKING.YES);

                if (res?.errorMessage) return null;
                if (res.amsCustomerInfoView.boLossMaxAmount && res.amsCustomerInfoView.boLossMaxAmount !== "") {
                    const amt = res.amsCustomerInfoView.boLossMaxAmount.replace(/[^0-9.]/g, '');
                    res.amsCustomerInfoView.boLossMaxAmount = floor(amt) + '';
                }

                this.showProfileMsg('MSG_TRS_NAF_0201', null, null);
                await this.$store.dispatch("editProfile/updateCustomerInfo", res);

                return {
                    maskingVerifiedPerSession: res.authenticateModel?.maskingVerifiedPerSession
                };
            },
            async runUnMaskingLogicForReportScreen() {
                const data = await this.getAuthenticationInfo(false);
                this.showProfileMsg('MSG_TRS_NAF_0201', null, null);
                return data;
            },
            async runUnMaskingLogicForWithdrawalScreen() {
                const data = await this.getAuthenticationInfo(false);
                this.showProfileMsg('MSG_TRS_NAF_0201', null, null);
                return data;
            },
            async getAuthenticationInfo(prepareToUnMask) {
                const res = await this.$service
                    .getService(IConstants.SERVICE_NAME.FIDO)
                    .fetchAuthenticationInfo(this.screenNameProps, prepareToUnMask);

                if (res?.errorMessage) return null;
                return res;
            },
            showProfileMsg(successMsg, errorMsg, verifyAuthenticatorFailMsg) {
                this.$modal.showProfileMessage({
                    message: {
                        successMessage: successMsg,
                        errorMessage: errorMsg,
                        verifyAuthenticatorFailMsg: verifyAuthenticatorFailMsg
                    },
                    callBackFunc: () => {
                        $("html, body").animate({scrollTop: 0}, "slow");
                    }
                })
            },
            getVerifyPasskeyFailedMsg() {
                return this.$t('MSG_TRS_NAF_0218', {supportLink: this.supportLink})
            }
        }
    }
</script>

<style scoped>
</style>
